// extracted by mini-css-extract-plugin
module.exports = {"transactionAmount":"transactionAmount__IXUB4","negative":"negative__is3aO","positive":"positive__ZjAdE"};